// Shared types for the 求人原稿生成(媒体別) feature.
// Used by both the frontend (src) and Cloudflare Pages Functions (functions).
//
// Design doc: docs/design/ad_generator_design.md
// 媒体スタイル:  docs/design/media_style_guide.md
// 項目構造:    docs/design/media_input_field_map.md
// セキュリティ:  docs/design/security_policy.md
//
// 公開予定の求人情報のみを扱う。求職者個人情報・社内秘情報は受け取らない。
// 推測で実数を埋めない(設計書 §3-2 厳守事項)。

/** 対応媒体(まずは Indeed / gaten職 / Engage の 3 媒体)。 */
export type AdGenMedia = 'indeed' | 'gaten' | 'engage';

export const AD_GEN_MEDIA_LABELS: Record<AdGenMedia, string> = {
  indeed: 'Indeed',
  gaten: 'gaten職',
  engage: 'Engage',
};

/** 入力ソース。form=会社情報フォーム(新規)/ draft=既存原稿の貼り付け。 */
export type AdGenInputMode = 'form' | 'draft';

/** 会社情報フォーム(form モード時の素材)。未入力欄は [要確認] になる。 */
export interface AdGenFormInput {
  companyName?: string;
  companyBusiness?: string;
  companyStrengths?: string;
  companyLocation?: string;
  jobTitle?: string;
  jobContent?: string;
  employmentType?: string;
  salary?: string;
  workingHoursHoliday?: string;
  requirements?: string;
  targetPersona?: string;
  pitchPoints?: string;
}

export interface AdGenRequest {
  inputMode: AdGenInputMode;
  form?: AdGenFormInput;
  draftText?: string;
  media: AdGenMedia[];
}

export interface AdGenResponse {
  /** 構造化 Markdown(`## (媒体) 向け原稿` / `### [(媒体)] 項目名`)。フロントで分割して描画。 */
  result: string;
  /** 使用した Gemini モデル名(表示・検証用)。 */
  model: string;
}
